import { Component, Inject, ViewEncapsulation } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { DialogGeneral } from 'app/dialogs/DialogGeneral';
import { formatBirthdayFromKennitala } from 'app/helpers/formatBirthdayFromKennitala';
import { formatDate } from 'app/helpers/formatDate';
import { formatKennitala } from 'app/helpers/formatKennitala';
import { ExposedListPublicRegistryCompaniesRes } from 'app/interfaces/responses/Exposed/exposedListPublicRegistryCompaniesRes';
import { LsrauthService } from 'app/services/api/lsrauth/lsrauth.service';
import { DialogThjodskraPersonDetails } from '../person-details/dialog-thjodskra-person-details';

export interface DialogThjodskraFirmDetailsData {
    data: ExposedListPublicRegistryCompaniesRes;
}

@Component({
    selector: 'dialog-thjodskra-firm-details',
    templateUrl: 'dialog-thjodskra-firm-details.html',
    styleUrls: ['dialog-thjodskra-firm-details.scss'],
    encapsulation: ViewEncapsulation.None,
})
export class DialogThjodskraFirmDetails extends DialogGeneral {
    constructor(
        public matDialogRef: MatDialogRef<DialogThjodskraPersonDetails>,
        public dialogRef: MatDialogRef<DialogThjodskraPersonDetails>,
        public dialog: MatDialog,
        public lsrauthService: LsrauthService,
        @Inject(MAT_DIALOG_DATA) public data: DialogThjodskraFirmDetailsData
    ) {
        super(dialogRef);
    }

    formatDate(d) {
        return formatDate(d, false);
    }

    formatBirthdayFromKennitala(kt) {
        return formatBirthdayFromKennitala(kt);
    }

    formatKennitala(kt) {
        return formatKennitala(kt);
    }
}
